import { environment } from './environment';
import { Config } from './../app/core/models/configuration/config.model';

export const load = () =>
  fetch(`/assets/env/env.${environment.name}.json`)
    .then(response => response.json())
    .then((external: Config) => Object.assign(environment, external));
